'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Select = function Select(props) {
	var wrapperClass = props.wrapperClass,
	    label = props.label,
	    rest = _objectWithoutProperties(props, ['wrapperClass', 'label']);

	return _react2.default.createElement(
		'div',
		{ className: "input-wrapper select-wrapper " + wrapperClass },
		label ? _react2.default.createElement(
			'label',
			{ htmlFor: '' },
			label
		) : null,
		_react2.default.createElement(_reactSelect2.default, rest)
	);
};

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Select.js
// module id = 152
// module chunks = 0